var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpired = function SvgExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2926",
    fillRule: "evenodd",
    d: "M22 .5C33.874.5 43.5 10.126 43.5 22S33.874 43.5 22 43.5.5 33.874.5 22 10.126.5 22 .5m0 2.606C11.565 3.106 3.106 11.565 3.106 22S11.565 40.894 22 40.894 40.894 32.435 40.894 22 32.434 3.106 22 3.106M21.5 8.5c.815 0 1.479.648 1.5 1.455V22.5h8.974c.843 0 1.526.672 1.526 1.5 0 .815-.662 1.479-1.486 1.5H21.526C20.683 25.5 20 24.828 20 24q.001-.262.085-.495a1.5 1.5 0 0 1-.084-.46L20 9.994c0-.825.672-1.494 1.5-1.494"
  })));
};
export default SvgExpired;